var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"book"},[_c('r-e-empty',{attrs:{"description":"暂无相关信息"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }